import React, { Component } from 'react';
import { Grid, Row, Col } from 'react-bootstrap';

import PasswordReset from 'components/FormInputs/PasswordReset.jsx'

class PasswordResetPage extends Component{
    constructor(props){
        super(props);
        this.state = {
            cardHidden: true
        }
    }
    componentDidMount(){
        setTimeout(function() { this.setState({cardHidden: false}); }.bind(this), 700);
    }

    render(){
        return (
            <Grid>
                <Row>
                    <Col md={4} sm={6} mdOffset={4} smOffset={3}>
                      <PasswordReset {...this.props}/>
                    </Col>
                </Row>
            </Grid>
        );
    }
}

export default PasswordResetPage;



// WEBPACK FOOTER //
// ./src/views/Pages/PasswordResetPage.jsx